import React from 'react';
import { HashtagCategoriesInput, HashtagCategoryItem } from './HashtagCategoriesInput';

interface HashtagCategoriesFieldProps {
  label: string;
  required?: boolean;
  value?: HashtagCategoryItem[];
  onChange: (_value: HashtagCategoryItem[]) => void;
  error?: string;
}

export const HashtagCategoriesField: React.FC<HashtagCategoriesFieldProps> = ({
  label,
  required = false,
  value = [],
  onChange,
  error,
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <HashtagCategoriesInput value={value} onChange={onChange} />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </>
  );
};
